import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.addEventListener('unhandledrejection', event => {
    if (event.reason && event.reason.message && event.reason.message.includes("Lock broken by another request with the 'steal' option")) {
        event.preventDefault(); // Suppress the error from causing a popup
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
